import React from 'react';
import { useTranslation } from 'react-i18next';

import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Wrapper } from 'components/atom/Grid';

import { ButtonClose, Container, Title } from './styles';

interface IHeaderContentProps {
  title: string;
  onClose?: () => void;
}

const HeaderContent: React.FC<IHeaderContentProps> = ({ title, onClose }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Wrapper>
        <Title>{title}</Title>

        {onClose && (
          <ButtonClose onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />

            <span>{t('meetings:actions.close')}</span>
          </ButtonClose>
        )}
      </Wrapper>
    </Container>
  );
};

export default HeaderContent;
